<template>
  <div class="container row">
    <div class="card mt-5 col-md-12" style="width: 90%">
      <div class="mt-3 mb-3">
        <div v-for="(l, i) in list" :key="i">
          <label class="mb-3 mt-3">{{ i + 1 }}. {{ l.questionname }}</label>
          <div class="form-check mb-3" v-for="a in l.key" :key="a.id">
            <input
              class="form-check-input"
              type="radio"
              :name="l.id"
              :id="a.id"
            />
            <label class="form-check-label" :for="a.id">
              {{ a.answer }}
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="social-auth-links text-center mb-3 mt-3">
        <button @click="save()" type="button" class="btn btn-success btn-sm">
          บันทึก
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import SubjectTestService from "../services/SubjectTestService.js";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      list: [],
      status: false,
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist() {
      SubjectTestService.getsubjecttests().then((res) => {
        var list = res.data;
        this.list = list;
        // console.log(this.list);
      });
    },
    generateanswer(list) {
      for (let l = 0; l < list.length; l++) {
        SubjectTestService.getanswersubjecttests(list[l].id).then((res) => {
          var answer = res.data;
          answer.push({
            answer: list[l].answer,
          });
          list[l].answers = answer;
        });
        this.status = true;
      }
      return list;
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}
.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
}
body {
  background-color: gray;
}
</style>
